import {
    store,
    getContext,
    getElement,
    withScope,
} from "@wordpress/interactivity";

let searchTimeout = null;

const { state, actions } = store("dock11/user-filter", {
    state: {
        get isCheckedSector() {
            const { selectedSectors, slug } = getContext();
            return selectedSectors.includes(slug);
        },
    },
    actions: {
        toggle() {
            const context = getContext();
            context.open = !context.open;
        },
        close() {
            const context = getContext();
            context.open = false;
        },
        submitClose() {
            const context = getContext();
            actions.emitFilterChange();
            context.open = false;
        },
        closeOnEscape(event) {
            if (event.key !== "Escape") return;
            const context = getContext();
            if (context.open) context.open = false;
        },
        closeOnClickAway(event) {
            const { ref } = getElement();
            if (ref && !ref.contains(event.target)) {
                const context = getContext();
                if (context.open) context.open = false;
            }
        },
        handleSearchKeydown(event) {
            if (event.key === "Enter") {
                event.preventDefault();
                clearTimeout(searchTimeout);
                actions.emitFilterChange();
            }
        },
        handleSearchInput(event) {
            const context = getContext();
            context.searchTerm = event.target.value;

            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(
                withScope(() => {
                    actions.emitFilterChange();
                }),
                300,
            );
        },
        handleSectorChange(event) {
            const context = getContext();
            const slug = context.slug;

            if (event.target.checked) {
                if (!context.selectedSectors.includes(slug)) {
                    context.selectedSectors.push(slug);
                }
            } else {
                context.selectedSectors = context.selectedSectors.filter(
                    (s) => s !== slug,
                );
            }
            actions.emitFilterChange();
        },
        emitFilterChange() {
            const context = getContext();
            actions.updateUrl();
            document.dispatchEvent(
                new CustomEvent("user-filter-change", {
                    detail: {
                        search: context.searchTerm,
                        sectors: context.selectedSectors,
                    },
                }),
            );
        },
        updateUrl() {
            const context = getContext();
            const params = new URLSearchParams();

            if (context.searchTerm) params.set("find", context.searchTerm);
            if (context.selectedSectors.length > 0) {
                params.set("sectors", context.selectedSectors.join(","));
            }

            const newUrl = params.toString()
                ? `${window.location.pathname}?${params.toString()}`
                : window.location.pathname;

            window.history.pushState({}, "", newUrl);
        },
    },
    callbacks: {
        init() {
            const context = getContext();
            const readFromUrl = withScope(() => {
                const params = new URLSearchParams(window.location.search);
                context.searchTerm = params.get("find") || "";
                const sectors = params.get("sectors");
                context.selectedSectors = sectors ? sectors.split(",") : [];
            });

            readFromUrl();
            window.addEventListener("popstate", readFromUrl);
        },
        focusInputOnOpen() {
            const context = getContext();
            const { ref } = getElement();
            if (context.open && ref) {
                const input = ref.querySelector("input");
                if (input) input.focus();
            }
        },
    },
});
